const SocialServiceCounter = () => {
    return (
        <>
            <div className="row">
                <div className="col-xxl-6 mb-4 order-5 order-xxl-0">
                    <div className="card h-100">
                        <div className="card-header">
                            <div className="card-title mb-0">
                                <h5 className="m-0">Vehicles overview</h5>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="d-none d-lg-flex vehicles-progress-labels mb-3">
                                <div className="vehicles-progress-label on-the-way-text" style={{ width: '39.7%' }}>On the way</div>
                                <div className="vehicles-progress-label unloading-text" style={{ width: '28.3%' }}>Unloading</div>
                                <div className="vehicles-progress-label loading-text" style={{ width: '17.4%' }}>Loading</div>
                                <div className="vehicles-progress-label waiting-text" style={{ width: '14.6%' }}>Waiting</div>
                            </div>
                            <div className="vehicles-overview-progress progress rounded-2 mb-3" style={{ height: 46 }}>
                                <div className="progress-bar fs-big fw-medium text-start bg-lighter text-body px-1 px-lg-3 rounded-start shadow-none" role="progressbar" style={{ width: '39.7%' }} aria-valuenow="39.7" aria-valuemin={0} aria-valuemax={100}>
                                    39.7%
                                </div>
                                <div className="progress-bar fs-big fw-medium text-start bg-primary px-1 px-lg-3 shadow-none" role="progressbar" style={{ width: '28.3%' }} aria-valuenow="28.3" aria-valuemin={0} aria-valuemax={100}>
                                    28.3%
                                </div>
                                <div className="progress-bar fs-big fw-medium text-start text-bg-info px-1 px-lg-3 shadow-none" role="progressbar" style={{ width: '17.4%' }} aria-valuenow="17.4" aria-valuemin={0} aria-valuemax={100}>
                                    17.4%
                                </div>
                                <div className="progress-bar fs-big fw-medium text-start bg-gray-900 px-1 px-lg-3 rounded-end shadow-none" role="progressbar" style={{ width: '14.6%' }} aria-valuenow="14.6" aria-valuemin={0} aria-valuemax={100}>
                                    14.6%
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table card-table">
                                    <tbody className="table-border-bottom-0">
                                        <tr>
                                            <td className="w-50 ps-0">
                                                <div className="d-flex justify-content-start align-items-center">
                                                    <div className="me-2">
                                                        <i className="bx bxs-truck" />
                                                    </div>
                                                    <h6 className="mb-0 fw-normal">On the way</h6>
                                                </div>
                                            </td>
                                            <td className="text-end pe-0 text-nowrap">
                                                <h6 className="mb-0">2hr 10min</h6>
                                            </td>
                                            <td className="text-end pe-0">
                                                <span className="fw-medium">39.7%</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-50 ps-0">
                                                <div className="d-flex justify-content-start align-items-center">
                                                    <div className="me-2">
                                                        <i className="bx bx-down-arrow-circle" />
                                                    </div>
                                                    <h6 className="mb-0 fw-normal">Unloading</h6>
                                                </div>
                                            </td>
                                            <td className="text-end pe-0 text-nowrap">
                                                <h6 className="mb-0">3hr 15min</h6>
                                            </td>
                                            <td className="text-end pe-0">
                                                <span className="fw-medium">28.3%</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-50 ps-0">
                                                <div className="d-flex justify-content-start align-items-center">
                                                    <div className="me-2">
                                                        <i className="bx bx-up-arrow-circle" />
                                                    </div>
                                                    <h6 className="mb-0 fw-normal">Loading</h6>
                                                </div>
                                            </td>
                                            <td className="text-end pe-0 text-nowrap">
                                                <h6 className="mb-0">1hr 24min</h6>
                                            </td>
                                            <td className="text-end pe-0">
                                                <span className="fw-medium">17.4%</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="w-50 ps-0">
                                                <div className="d-flex justify-content-start align-items-center">
                                                    <div className="me-2">
                                                        <i className="bx bx-time-five" />
                                                    </div>
                                                    <h6 className="mb-0 fw-normal">Waiting</h6>
                                                </div>
                                            </td>
                                            <td className="text-end pe-0 text-nowrap">
                                                <h6 className="mb-0">5hr 19min</h6>
                                            </td>
                                            <td className="text-end pe-0">
                                                <span className="fw-medium">14.6%</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>




                <div className="col-lg-6 col-xxl-6 mb-4 order-3 order-xxl-1">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <div className="card-title mb-0">
                                <h5 className="m-0 me-2">Shipment statistics</h5>
                                <small className="text-muted">Total number of deliveries 23.8k</small>
                            </div>
                            <div className="dropdown">
                                <button type="button" className="btn btn-label-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                    January
                                </button>
                                <ul className="dropdown-menu">
                                    <li><a className="dropdown-item" href="javascript:void(0);">January</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">February</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">March</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">April</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">May</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">June</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">July</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">August</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">September</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">October</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">November</a></li>
                                    <li><a className="dropdown-item" href="javascript:void(0);">December</a></li>
                                </ul>
                            </div>
                        </div>
                        <div className="card-body">
                            <div id="shipmentStatisticsChart" />
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}

export default SocialServiceCounter;